// extracted by css-extract-rspack-plugin
export default {"actionBar":"actionBar-uGuPsV","compact":"compact-tLsYBh"};